const QuickReplyManage = () =>
  import('@/views/main/wechatMgmt/quickReplyManage/QuickReplyManage.vue')
export default {
  path: '/main/wechatMgmt/quickReplyManage',
  name: 'QuickReplyManage',
  component: QuickReplyManage
}
